import { Fraction } from 'bi-fraction';
import { ERC20__factory } from '../contracts';
import { getContract } from './getContract';
export const getErc20Approval = (chainId, tokenAddress, owner, spender) => {
    const getSc = (signer) => getContract(chainId, tokenAddress, ERC20__factory.abi, signer);
    const getAllowance = async () => {
        return new Fraction(await getSc().allowance(owner, spender));
    };
    return {
        getAllowance,
        isNeedToApprove: async (amount) => {
            return (await getAllowance()).lt(amount);
        },
        approve: async (amount, signer) => (await getSc(signer).approve(spender, amount)).wait(),
    };
};
